import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { InitialAssessmentForm } from '../../data/initial-assessment-form';
import { IFormTypes } from '../../models/form-types';
import { FormGroup } from '@angular/forms';
import { IFormComponent } from '../../models/i-form-component';
import { OptionItem } from '../../data/option-item';

@Component({
  selector: 'app-business-enquiry',
  templateUrl: './business-enquiry.component.html',
  styleUrl: './business-enquiry.component.scss'
})
export class BusinessEnquiryComponent implements IFormComponent {
 
  @Input()model!: InitialAssessmentForm;
  @Input()formTypes!: IFormTypes;
  @Input() phoneTypes!: OptionItem[];

  @Output() formReady = new EventEmitter<FormGroup>();
  
  @ViewChild('businessEnquiryForm') businessEnquiryFormComponent?: any;
  @ViewChild('feedbackForm') feedbackFormComponent?: any;
  @ViewChild('dataProtectionForm') dataProtectionFormComponent?: any;

  onChildFormReady(childForm: FormGroup) {

      this.formReady.emit(childForm);
  }

  isFormValid(): boolean {
    const businessEnquiryFormValid = this.businessEnquiryFormComponent?.businessEnquiryForm.valid ?? false;
    const feedbackFormValid = this.feedbackFormComponent?.feedbackForm.valid ?? false;
    const dataProtectionFormValid = this.dataProtectionFormComponent?.dataProtectionForm.valid ?? false;
    return businessEnquiryFormValid && feedbackFormValid && dataProtectionFormValid;
  }

  markFormAsTouched(): void {
    this.businessEnquiryFormComponent?.businessEnquiryForm?.markAllAsTouched();
    this.feedbackFormComponent?.feedbackForm?.markAllAsTouched();
    this.dataProtectionFormComponent?.dataProtectionForm?.markAllAsTouched();
  }

  
}
